import Switch from 'antd-mobile/lib/switch';
export default Switch;



// WEBPACK FOOTER //
// ./components/switch/index.tsx